export const INFO_ITEMS = [
  {
    description:
      "L'offre zLawyer est sans engagement. Vous pouvez stopper votre abonnement à tout moment mais nous serions attristés de vous voir partir.",
    highlight: 'sans engagement',
    title: 'Y a t-il un engagement ?',
  },
  {
    description:
      "Une fois abonné, vous bénéficiez d'un accès au support utilisateur et aux mises à jour sans frais complémentaires.",
    highlight: 'sans frais complémentaires',
    title: 'Y a t-il des frais cachés ?',
  },
  {
    description:
      "Que vos données proviennent d'un autre éditeur ou directement depuis Excel, nous vous offrons l'import de vos données. C'est quand même plus facile quand on ne recommence pas à zéro.",
    highlight: "nous vous offrons l'import de vos données",
    title: "Comment j'importe mes données ?",
  },
  {
    description:
      "Oui sans problème. Si un collaborateur quitte le cabinet et qu'il n'est pas remplacé, vous pourrez adapter votre abonnement en conséquence.",
    highlight: 'adapter votre abonnement',
    title: 'Puis-je adapter mon abonnement ?',
  },
];
